import type { Container, ExtendedBlock, RepeatableContainer, TabbedContainer } from 'widget-components/integrations/CustomPage/types'

export function isNestableBlock(block: ExtendedBlock): block is ExtendedBlock<Container> | ExtendedBlock<RepeatableContainer> | ExtendedBlock<TabbedContainer> {
    return ['CONTAINER', 'REPEATABLE_CONTAINER', 'TABBED_CONTAINER'].includes(block.type)
}